export default __webpack_public_path__ + "static/media/Img-05.009d844b.jpg";